import { ReactNode } from 'react';

import Button from '@common/Button/Button';
import Icon from '@common/Icons/Icon';
import { H5 } from '@common/headline';

type Props = {
  nextPageHref: string;
  children: ReactNode;
};

const ArticleNextButton = ({ nextPageHref, children }: Props): JSX.Element => (
  <div className="mx-auto mb-16 max-w-xs">
    <a href={nextPageHref} className="flex items-center justify-center gap-2">
      <H5>{children}</H5>
      <Button
        colour="NavyBlue"
        type="Primary"
        icon={<Icon name="rightArrow" />}
      />
    </a>
  </div>
);

export default ArticleNextButton;
